// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","socialicon":"Footer_socialicon__5QORK"};